












































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import StarIcon from '../icons/StarIcon.vue';
import UmbrellaIcon from '../icons/UmbrellaIcon.vue';
import { SearchResultProcess } from '@/store/modules/searchInterfaces';
import { StatusLabels } from '@/models/status';
import { RunPeriodLabels } from '@/models/runperiod';
import { DomainLabels } from '@/models/domain';
import { TypeKeys } from '@/models/types';
import { ProcessModule } from '@/store/modules/process';
import { PhaseLabels } from '@/models/phase';
import moment from 'moment';
import { SearchModule } from '@/store/modules/search';

@Component({
  components: {
    StarIcon,
    UmbrellaIcon
  }
})
export default class SearchResultRow extends Vue {
  @Prop(Object)
  process!: SearchResultProcess;
  @Prop(Boolean)
  bookmarked!: boolean;

  get state() {
    return SearchModule;
  }

  processBookmarked = this.process.hasBookmarked;
  StatusLabels = StatusLabels;
  RunPeriodLabels = RunPeriodLabels;
  PhaseLabels = PhaseLabels;

  get isChildProcess() {
    return this.process.type === TypeKeys.CHILD;
  }

  get domains() {
    return this.process.domains.map(domain => DomainLabels[domain]).join(', ');
  }

  get technologies() {
    return this.process.technologies.map(technology => technology.name).join(', ');
  }

  get timeSpendHours() {
    if (this.process.timeSpendOccurancesPerEmployee == null || this.process.timeSpendPerOccurance == null) {
      return '0';
    }
    
    const total = this.process.timeSpendOccurancesPerEmployee * this.process.timeSpendPerOccurance;
    const hours = (total / 60) * (this.process.timeSpendPercentageDigital / 100);
    const result = hours.toLocaleString('da-DK', { minimumFractionDigits: 2 }) || '0';
    return result;
  }

  get hasAttachments() {
    return this.process.hasAttachments ? 'Ja' : 'Nej';
  }

  get lastChanged() {
    return moment(this.process.lastChanged).format('DD-MM-YYYY');
  }

  async setProcessBookmark() {
    const res = await ProcessModule.setBookmarkFromSearch({
      id: this.process.id,
      hasBookmarked: !this.processBookmarked
    });
    this.processBookmarked = res ? !this.processBookmarked : this.processBookmarked;
  }

  toDetails(id: number, searchWord: string | null) {
    if (searchWord == null) {
      this.$router.push('/details/' + id);
    } else {
      this.$router.push('/details/' + id + '?search=' + searchWord);
    }
  }
}
